import { FC, ReactElement } from 'react'
import Link from 'next/link'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import classNames from 'classnames'
import styles from './index.module.scss'
import { ICompanyBase } from '../../../types'
import { getCompanyLogo, getFormattedAmount } from '../../../utils'
import { StatusListItem } from '../../atoms/StatusListItem'
import { Tag } from '../../atoms/Tag'
import { LocationList } from '../../atoms/LocationList'
import { ShowButtonForMobile } from '../../molecules/ShowButtonForMobile'
import { Avatar } from '../../atoms/Avatar'

type Props = {
  company: ICompanyBase
  renderHeading: () => ReactElement
  renderFooter: () => ReactElement
}

export const JobPageSidebar: FC<Props> = observer(({ company, renderHeading, renderFooter }) => {
  const { t } = useTranslation(['companies-[id]', 'companies-users-[id]'])

  const className = classNames(styles.container, {
    [styles.containerWithAlert]: company?.companyMembers?.length === 0,
  })

  return (
    <div className={className}>
      <div className={styles.heading}>{renderHeading()}</div>
      <div>
        <Link href={`/companies/${company?.slug}`}>
          <a className={styles.profile}>
            <div className={styles.profile__avatar}>
              <Avatar src={getCompanyLogo(company)} alt={company?.name} />
            </div>
            <div className={styles.profile__name}>{company?.name}</div>
          </a>
        </Link>
      </div>

      <ShowButtonForMobile>
        {!company?.isVc && company?.markets.length > 0 && (
          <div className={styles.marketList}>
            {company?.markets.map((market) => (
              <div key={market.id} className={styles.marketTag__item}>
                <Tag>{market.name}</Tag>
              </div>
            ))}
          </div>
        )}

        <div className={styles.statusList}>
          {company?.url && (
            <div className={styles.statusList__item}>
              <StatusListItem isLink href={company?.url} name='HP' value={company?.url} />
            </div>
          )}
          {!company?.isVc && (
            <>
              {company?.round && (
                <div className={styles.statusList__item}>
                  <StatusListItem name={t('ステージ')} value={t(company?.round.name)} />
                </div>
              )}
              <div className={styles.statusList__item}>
                <StatusListItem
                  name={t('合計資金調達額')}
                  value={getFormattedAmount(Number(company?.totalFundingAmount), company?.currencyUnit)}
                />
              </div>
            </>
          )}
          {/* TODO: 設立年月を設定 */}
          <div className={styles.statusList__item}>
            <StatusListItem name={t('従業員数')} value={t(company?.companySize)} />
          </div>
          <div className={styles.statusList__item}>
            <LocationList name={t('companies-users-[id]:所在地')} locations={company?.locations} />
          </div>
          <div className={styles.statusList__item}>{renderFooter()}</div>
        </div>
      </ShowButtonForMobile>
    </div>
  )
})
